module.exports = __webpack_public_path__ + "components/weather-icon/static/nightmodrain-8036acb9a0310b29ce2b4c0947de962e.webp";